'use client';

import { useOnMount } from '@src/hooks/useOnMount';
import { COOKIES } from '@src/utils/constants.util';
import { getBrowserCookie, setBrowserCookie } from '@src/utils/cookies.util';
import { getDeviceTimezone } from '@src/utils/timezone.util';

// Lets the server read the device timezone. Written once per document load.
export function useTimezoneCookie() {
  useOnMount(_temp);
}
function _temp() {
  const timezone = getDeviceTimezone();
  if (!timezone || getBrowserCookie(COOKIES.timezone) === timezone) {
    return;
  }
  setBrowserCookie(COOKIES.timezone, timezone);
}